var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 60,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "evenodd",
    d: "M51.866 44.029c-1.395 3.111-2.064 4.498-3.862 7.255-2.508 3.843-6.041 8.633-10.426 8.667-3.891.041-4.893-2.55-10.176-2.521-5.282.027-6.381 2.566-10.28 2.528-4.381-.037-7.731-4.359-10.239-8.203-7.009-10.743-7.75-23.356-3.425-30.064 3.077-4.764 7.929-7.55 12.486-7.55 4.639 0 7.559 2.562 11.402 2.562 3.727 0 5.996-2.569 11.361-2.569 4.064 0 8.367 2.229 11.428 6.069-10.037 5.538-8.411 19.964 1.731 23.826zM25.47 14.526c-.636-3.481.994-7.062 2.975-9.475 2.173-2.658 5.899-4.7 9.088-4.92.535 3.634-.942 7.194-2.893 9.711-2.086 2.703-5.686 4.793-9.17 4.684z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMac);
export default __webpack_public_path__ + "static/media/mac.cfc2a623dd26f746e09647cae20c4b0b.svg";
export { ForwardRef as ReactComponent };